export default {
    url: '',
    template: `
        <div class="heading01 type01">
            <h1>{{ 'Employee groups' | translate }}</h1>
        </div>
        <ul class="tabs01">
            <li><a ui-sref="authorized.user.group.list.department()" ui-sref-active="active">{{ 'Departments' | translate }}</a></li>
            <li><a ui-sref="authorized.user.group.list.role()" ui-sref-active="active">{{ 'Roles' | translate }}</a></li>
            <li><a ui-sref="authorized.user.group.list.level()" ui-sref-active="active">{{ 'Levels' | translate }}</a></li>
        </ul>
        <ui-view></ui-view>
    `,
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/list/index.js